import React, { PropTypes } from 'react'
import { Relayout, RelayoutItem } from 'relayout'
import CSSModules from 'react-css-modules'

import DealListItem from 'components/deal-list-item'
import Loader from 'components/loader'

import styles from './deal-list.css'

const DealList = ({ currencyCode, dealsErrors, deals, editable, onChange, saving }) => (
  <div styleName={editable ? 'deal-list-editable' : 'deal-list-normal'}>
    {saving &&
      <div styleName="overlay">
        <Loader center />
      </div>
    }
    <div styleName={editable ? 'header-editable' : 'header-normal'}>
      <Relayout>
        <RelayoutItem sm="12" lg="4">
          <div styleName="first">Ticket type</div>
        </RelayoutItem>
        <RelayoutItem sm="12" lg="2">
          <div styleName="item">Ticket price</div>
        </RelayoutItem>
        <RelayoutItem sm="12" lg="2">
          <div styleName="item">Tickets sold</div>
        </RelayoutItem>
        <RelayoutItem sm="12" lg="2">
          <div styleName="item">Revenue</div>
        </RelayoutItem>
      </Relayout>
    </div>
    {deals && deals.map((deal, index) => (
      <DealListItem
        dealErrors={dealsErrors && dealsErrors[deal.id]}
        key={index}
        currencyCode={currencyCode}
        deal={deal}
        editable={editable}
        onChange={onChange}
      />
    ))}
  </div>
)

DealList.propTypes = {
  currencyCode: PropTypes.string,
  dealsErrors: PropTypes.object,
  deals: PropTypes.array,
  editable: PropTypes.bool,
  onChange: PropTypes.func,
  saving: PropTypes.bool,
}

export default CSSModules(DealList, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/deal-list/deal-list.js
 **/